export default "__VITE_ASSET__CrddAqoB__"